<template>
  <div>
    <input v-bind:value="value" v-on:input="$emit('input', $event.target.checked)" :checked="isChecked" :id="dataInput" :disabled="readonly" type="checkbox" />
    <label v-if="id == 'term-condition'" :for="dataInput">
      <div v-if="$texts.termsConditions" v-html="$texts.termsConditions"></div>
      <span v-else>{{ label }}</span>
    </label>
    <label v-else-if="id == 'privacy-policy'" :for="dataInput">
      <div v-if="$texts.privacyPolicy" v-html="$texts.privacyPolicy"></div>
      <span v-else>{{ label }}</span>
    </label>
    <label v-else-if="id == 'email-marketing'" :for="dataInput">
      <p v-if="$texts.acceptMarketing" v-html="$texts.acceptMarketing"></p>
      <span v-else>Acceptér markedsføring</span>
    </label>
    <label v-else-if="id == 'extra-terms'" :for="dataInput">
      <div v-html="$texts.extraTerms"></div>
    </label>
    <label v-else-if="id == 'term-condition-register-card'" :for="dataInput">
      <span v-html="$texts.termsConditionsRegisterCard"></span>
    </label>
    <label v-else :for="dataInput">
      <span>{{ label }}</span>
    </label>
    <small class="error">{{ validation }}</small>
  </div>
</template>
<script>
export default {
  name: 'InputCheckbox',
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    dataInput: {
      type: String,
      default: null,
    },
    validation: {
      type: String,
      default: '',
    },
    readonly: {
      default: null,
    },
  },
  computed: {
    isChecked() {
      return this.value === '1' || this.value === true
    },
  },
}
</script>
